export default __webpack_public_path__ + "static/media/button-right-decoration-border.a2734c95.svg";